import { Filter } from '../ProjectsFilter';

export const defaultProjectsFilter: Filter = {
  search: '',
  initialTermFrom: null,
  initialTermTo: null,
  interestRateFrom: null,
  interestRateTo: null,
  simpleInterestRateFrom: null,
  simpleInterestRateTo: null,
  statuses: [],
};
